import { useI18n } from "@/lib/i18n";

/**
 * Compact IT | EN toggle. Renders two pill buttons; the active one glows
 * in Brema yellow. Persists to localStorage automatically via I18nProvider.
 */
export default function LangToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  const Btn = ({ code, label }) => (
    <button
      onClick={() => setLang(code)}
      data-testid={`lang-toggle-${code}`}
      className={`px-2.5 py-1 font-mono text-[11px] uppercase tracking-[0.2em] transition-all ${
        lang === code
          ? "bg-brema-yellow text-brema-obsidian"
          : "text-zinc-300 hover:text-brema-yellow"
      }`}
    >
      {label}
    </button>
  );
  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center border border-white/15 divide-x divide-white/10 ${className}`}
    >
      <Btn code="it" label="IT" />
      <Btn code="en" label="EN" />
    </div>
  );
}
